// The keys and the values are always in the UTF-16 string format,
// which uses two bytes per character

const SESSION_STORAGE_AUTH_PROPERTIES = {
  SET_API_KEY: null,
  SET_PLATFORM_USER_ID: null,
  SET_AUTH_USER_AVATAR: null
};
const getSessionStorageOrDefault = (key, defaultValue) => {
  const stored = sessionStorage.getItem(key);
  if (!stored) {
    return defaultValue;
  }
  return stored;
};
const setSessionStorage = (key, value) => {
  sessionStorage.setItem(key, value);
};
const getSessionStorage = () => {
  const obj = {};
  for (const prop in SESSION_STORAGE_AUTH_PROPERTIES) {
    obj[prop] = sessionStorage.getItem(prop);
  }
  return obj;
};
export { getSessionStorage, setSessionStorage, SESSION_STORAGE_AUTH_PROPERTIES, getSessionStorageOrDefault };
//# sourceMappingURL=sessions.js.map